import React from 'react';
import { connect } from 'react-redux';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import Heading from '@marvelapp/marvel-ui/heading';
import MarvelLink from '@marvelapp/marvel-ui/link';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Page from 'marketing-website/components/modules/Page';
import SignupForm from 'marketing-website/components/modules/SignupForm';
import AccountPagesWrap from 'marketing-website/components/modules/AccountPagesWrap';
import Maintenance from 'marketing-website/components/modules/Maintenance';
import { formSignupRegistrationPageId } from 'marketing-website/configs/hubspot';
import metaData from 'marketing-website/data/metadata.js';

import { shouldShowFullForm } from 'marketing-website/selectors';
import {
  getCommenterParam,
  getNextSignupRedirect,
  getUrlWithRedirect,
} from 'marketing-website/utils/forms';
import { SIGNIN } from 'marketing-website/constants/urls';

function SignUp({ showFullForm, history, data }) {
  const isCommenter = getCommenterParam();

  const meta = {
    title: metaData.signup.title,
    meta: [
      {
        name: 'description',
        content: metaData.signup.description,
      },
      { name: 'keywords', content: metaData.signup.keywords },
    ],
    header: false,
  };

  if (data.site.siteMetadata.siteMaintenance) {
    return (
      <Page {...meta}>
        <AccountPagesWrap history={history} isSignUpPage>
          <Maintenance />
          <div />
        </AccountPagesWrap>
      </Page>
    );
  }

  const heading = isCommenter
    ? 'Sign up to leave a comment'
    : 'Create your free account';
  const copy = isCommenter ? (
    <Spacing type="margin" size="l" position="bottom">
      <Paragraph size="m" color="slate">
        This is so we can send you comment notifications and updates for the
        projects you comment on.
      </Paragraph>
    </Spacing>
  ) : null;

  let messaging = {
    header: (
      <Spacing type="margin" size={isCommenter ? 'm' : 'l'} position="bottom">
        <Spacing type="margin" size="xl" sizeM="0" position="right">
          <MaxWidth value={280}>
            <Heading tag="h1" size="xxxl" weight="bold">
              {heading}
            </Heading>
          </MaxWidth>
        </Spacing>
      </Spacing>
    ),
    copy,
  };

  let buttonTxt = 'Create your free account';

  if (!showFullForm) {
    messaging = {
      header: (
        <Heading tag="h1" size="xl" weight="semibold">
          Finish your sign up
        </Heading>
      ),
      copy: (
        <Paragraph size="m" color="slate">
          Enter the details below to set up your account.
        </Paragraph>
      ),
    };

    buttonTxt = 'Finish';
  }

  const redirectTo = getNextSignupRedirect();
  const signinLinkWithRedirect = getUrlWithRedirect(SIGNIN);

  return (
    <Page {...meta}>
      <AccountPagesWrap history={history} isSignUpPage>
        <SignupForm
          messaging={messaging}
          redirectTo={redirectTo}
          buttonTxt={buttonTxt}
          hubspotId={formSignupRegistrationPageId}
          isCommenter={isCommenter}
        />
        <Spacing type="margin" position="topBottom" size="m">
          <Paragraph size="m" color="slate">
            By signing up, you agree to our{' '}
            <Link to="/terms">
              <MarvelLink type="blue">
                communications and usage terms
              </MarvelLink>
            </Link>{' '}
            <span className="breakPointM-display-block">
              Already have an account?{' '}
              <Link to={signinLinkWithRedirect} type="blue">
                <MarvelLink type="blue">Sign in</MarvelLink>
              </Link>
            </span>
          </Paragraph>
        </Spacing>
      </AccountPagesWrap>
    </Page>
  );
}

export const SIGNUP_PAGE_QUERY = graphql`
  query SignUpPageQuery {
    site {
      siteMetadata {
        siteMaintenance
      }
    }
  }
`;

SignUp.propTypes = {
  showFullForm: PropTypes.bool,
  history: PropTypes.object.isRequired,
  data: PropTypes.shape({
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        siteMaintenance: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

SignUp.defaultProps = {
  showFullForm: true,
};

function mapStateToProps(state) {
  return {
    showFullForm: shouldShowFullForm(state),
  };
}

export default connect(mapStateToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/pages/signup/index.js